import { MapPin, Phone } from "lucide-react";
import { useWa } from "@/lib/content";
import { useContent, rich } from "@/lib/content";
import { Reveal, SectionTitle, WhatsIcon } from "./Primitives";

export const Sucursales = () => {
  const { BRANCHES, TEXTS: T } = useContent();
  const waLink = useWa();
  return (
  <section id="sucursales" data-testid="sucursales-section" className="bg-roast py-20 md:py-28 lg:py-40">
    <div className="mx-auto max-w-[1400px] px-5 md:px-10">
      <SectionTitle className="mb-16" eyebrow={T.suc_eyebrow} title={rich(T.suc_title)} de={T.suc_de} testid="sucursales-title" />
      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {BRANCHES.map((b, i) => (
          <Reveal key={b.key} delay={i * 0.1} className={i % 2 ? "lg:mt-12" : ""}>
            <article data-testid={`branch-card-${b.key}`} className="group flex h-full flex-col overflow-hidden rounded-3xl border border-gold/15 bg-espresso">
              <div className="overflow-hidden">
                <img src={b.img} alt={`Sucursal ${b.name}`} loading="lazy" className="aspect-[16/10] w-full object-cover transition-transform duration-[1.2s] group-hover:scale-110 sm:aspect-square" />
              </div>
              <div className="flex flex-1 flex-col p-6">
                <h3 className="font-display text-3xl leading-tight text-cream">{b.name}</h3>
                <p className="mt-3 flex-1 font-sans text-sm leading-relaxed text-sand">{b.address}</p>
                <a data-testid={`branch-tel-${b.key}`} href={`tel:+52${b.tel.replace(/\./g, "")}`} className="mt-5 flex items-center gap-2 font-sans text-sm text-cream hover:text-gold">
                  <Phone size={15} className="text-gold" /> Tel. {b.tel}
                </a>
                <div className="mt-5 flex flex-wrap gap-2">
                  <a data-testid={`branch-map-${b.key}`} href={b.map} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 rounded-full border border-gold/30 px-4 py-2 font-sans text-xs text-cream transition-colors hover:bg-gold hover:text-espresso">
                    <MapPin size={14} /> {T.btn_suc_map}
                  </a>
                </div>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
  );
};
